import { useState, useEffect } from 'preact/hooks';
import { formatLocations } from 'utils/storefront/format-resource';
import { getStoreStatus } from './helpers';

const useCurrentStore = () => {
  const [store, setStore] = useState(null);


  useEffect(() => {
    const getCurrentStore = () => {
      const storeId = localStorage.getItem('userSavedStoreId');
      if (storeId) {
        const allLocations = sessionStorage.getItem('allLocations')
          ? formatLocations(JSON.parse(sessionStorage.getItem('allLocations')))
          : {};
        const location = allLocations?.[storeId];

        if (location) {
          setStore({
            ...location,
            status: getStoreStatus(location),
          });
        } else {
          setStore(null);
        }
      } else {
        setStore(null);
      }
    };
    getCurrentStore();
    document.addEventListener('savedStoreChanged', getCurrentStore);
    document.addEventListener('storeLocationsLoaded', getCurrentStore);
    return () => {
      document.removeEventListener('savedStoreChanged', getCurrentStore);
      document.removeEventListener('storeLocationsLoaded', getCurrentStore);
    };
  }, []);

  return store;
};

export default useCurrentStore;
